import React from 'react';
import type { SvgProps } from 'react-native-svg';
import { Path, Svg } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

export interface UserDeniedIconProps extends SvgProps {
  size?: number;
  color?: keyof AppColors;
}

const UserDeniedIcon: React.FC<UserDeniedIconProps> = ({
  size = 20,
  color = 'iconPrimary',
  ...props
}) => {
  const { theme: colors } = useUnistyles();

  return (
    <Svg width={size} height={size} viewBox="0 0 20 20" fill="none" {...props}>
      <Path
        d="M14.1202 17.0529C14.2818 16.776 14.2955 16.4308 14.1566 16.1406L12.8734 13.4313C12.42 12.4758 11.4914 11.8729 10.4764 11.875H3.77548C2.76045 11.8729 1.83186 12.4758 1.37848 13.4313L0.095323 16.1406C-0.043658 16.4308 -0.0299141 16.776 0.131646 17.0529C0.293206 17.3299 0.579542 17.499 0.888384 17.5H13.3635C13.6723 17.499 13.9587 17.3299 14.1202 17.0529Z"
        fill={colors[color]}
      />
      <Path
        d="M10.6903 6.25C10.6903 8.32107 9.09446 10 7.12594 10C5.15742 10 3.56162 8.32107 3.56162 6.25C3.56162 4.17893 5.15742 2.5 7.12594 2.5C9.09446 2.5 10.6903 4.17893 10.6903 6.25Z"
        fill={colors[color]}
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.25 5.25C14.1789 5.25 12.5 6.92893 12.5 9C12.5 11.0711 14.1789 12.75 16.25 12.75C18.3211 12.75 20 11.0711 20 9C20 6.92893 18.3211 5.25 16.25 5.25ZM14 9C14 7.75736 15.0074 6.75 16.25 6.75C16.5974 6.75 16.9263 6.82871 17.2201 6.96928L14.2193 9.97006C14.0787 9.67633 14 9.34736 14 9ZM15.2799 11.0307L18.2807 8.02994C18.4213 8.32366 18.5 8.65264 18.5 9C18.5 10.2426 17.4926 11.25 16.25 11.25C15.9026 11.25 15.5737 11.1713 15.2799 11.0307Z"
        fill={colors[color]}
      />
    </Svg>
  );
};

UserDeniedIcon.displayName = 'UserDeniedIcon';

export { UserDeniedIcon };
